import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollRestoration = () => {
  const location = useLocation();

  useEffect(() => {
    // Only scroll to top for new navigations (not browser back/forward)
    // Browser back/forward will automatically restore scroll position
    if (location.state?.scrollToTop !== false) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return null;
};

export default ScrollRestoration; 